import { defineModelForFields } from "App/model";

const fields = [
  {
    name: "email",
    type: "email",
    defaultValue: () => "",
    validate: {
      email: true,
    },
  },
];

export default defineModelForFields(fields);
